var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { logger as log, mergeQueryString, updateSearch } from 'bernie-core';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { useLocalization } from '@shared-ui/localization-context';
import { LineOfBusinessDomain, OneKeyBanner, PageLocation } from '@shared-ui/retail-loyalty-one-key-banner';
import { RefProviderRoot } from '@shared-ui/ref-context';
import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkViewTemplateSearchResults } from 'uitk-react-view';
import { SortAndFiltersViewType, getActivitySearchCriteriaFromQueryParams } from '@shared-ui/retail-sort-and-filter-activity';
import { ActivitySearchForm } from '@shared-ui/retail-search-tools-product';
import { PageId, getPageName } from '../utils/page-ids';
import { STORE_EVENTS } from '../stores/store-events';
import { getClientGeoLocation, LandingPageType } from '../utils/geoLocation';
import { useStores } from '../utils/hooks';
import { getIsoFormatDateFromDateString } from '../helpers/date-helper';
import { updateSearchQueryString } from '../helpers/activity-search-helper';
import { Breadcrumbs } from './srp/modules/module-components/breadcrumbs';
import { CustomerNotifications } from './common/customer-notifications';
import { DestinationView } from './srp/modules/destination-view';
import { ErrorBanner, ErrorMessageType, SearchMessageBanner } from './common/banners';
import { FilterPills, SortFilter, SortFilterDialog } from './srp/sort-filter';
import { MesoDisplayAd } from './meso';
import { SrpSearchForm } from './activity-search-form';
import { UniversalSortFilterWrapper } from './srp/sort-filter/universal-sort-filter';
import { updateQueryForSearch, getDateRangeFromUrl } from './utils/update-query';
var RENDERING_ACTIVITY_SEARCH_COMPONENT = new SystemEvent(SystemEventLevel.INFO, 'RENDERING_ACTIVITY_SEARCH_COMPONENT');
export var ActivitySearch = log('activity-search')(observer(function (_a) {
  var _b, _c, _d;
  var logger = _a.logger;
  var _e = useStores(),
    activitySearchStore = _e.activitySearchStore,
    searchCriteriaStore = _e.searchCriteriaStore,
    advertising = _e.advertising;
  var history = useHistory();
  var location = useLocation();
  var formatText = useLocalization().formatText;
  var inputs = getActivitySearchCriteriaFromQueryParams(new URLSearchParams(location.search));
  var getMessages = function (searchSummary) {
    if (searchSummary && searchSummary.messages && searchSummary.messages.length > 0 && searchSummary.messages) {
      return searchSummary.messages;
    }
    return null;
  };
  if (!activitySearchStore || !searchCriteriaStore) {
    return null;
  }
  var loadingActivities = activitySearchStore.loadingActivities,
    searchSummary = activitySearchStore.searchSummary,
    searchError = activitySearchStore.searchError,
    showMoreLoading = activitySearchStore.showMoreLoading,
    universalSortAndFilter = activitySearchStore.universalSortAndFilter;
  var searchQuery = searchCriteriaStore.searchQuery,
    numOfDaysBookableInAdvance = searchCriteriaStore.numOfDaysBookableInAdvance;
  var messages = getMessages(searchSummary);
  var _f = universalSortAndFilter || {},
    appliedFilters = _f.appliedFilters,
    clearAll = _f.clearAll;
  var isActivityGroupsAvailable = activitySearchStore.activityGroups && activitySearchStore.activityGroups.length > 0;
  var isValidActivityGroupsAvailable = isActivityGroupsAvailable && activitySearchStore.activityGroups[0].activityTiles.length > 0;
  var localizedPageTitle = ((_b = activitySearchStore.pageInfo) === null || _b === void 0 ? void 0 : _b.title) || formatText('lx.search.page.title', activitySearchStore.regionName);
  var regionId = searchQuery.rid ? searchQuery.rid : '';
  var localDateFormat = searchCriteriaStore.localDateFormat ? searchCriteriaStore.localDateFormat : '';
  var startDate = getIsoFormatDateFromDateString(searchQuery.startDate, localDateFormat);
  var endDate = getIsoFormatDateFromDateString(searchQuery.endDate, localDateFormat);
  var _g = __read(React.useState(false), 2),
    skipQuery = _g[0],
    setSkipQuery = _g[1];
  advertising.trigger(getPageName(PageId.ACTIVITY_SEARCH));
  var setPageTitle = function () {
    var _a, _b;
    if (((_b = (_a = activitySearchStore.searchSummary) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.title) && typeof document !== 'undefined') {
      document.title = activitySearchStore.searchSummary.pageInfo.title;
    }
  };
  var submitNewSearch = function (query) {
    if (!location) {
      return;
    }
    updateSearch({
      history: history,
      location: location,
      newParams: query,
      newState: {},
      replace: false
    });
  };
  React.useEffect(function () {
    var regionType = searchCriteriaStore.searchQuery.regionType;
    if (regionType === LandingPageType.ULTRA_LOCAL || regionType === LandingPageType.LOCAL) {
      getClientGeoLocation().then(function (position) {
        var latLong = "".concat(position.coords.latitude, ",").concat(position.coords.longitude);
        var updatedQueryString = mergeQueryString(location.search, {
          latLong: latLong,
          rid: null,
          landingPage: null
        });
        updateSearch({
          history: history,
          location: location,
          newParams: updatedQueryString,
          newState: {},
          replace: true
        });
      }).catch(function (error) {
        logger.logEvent(STORE_EVENTS.USER_GEO_LOCATION_FETCH_ERROR, error);
      });
    }
  }, [searchCriteriaStore.searchQuery.regionType]);
  React.useEffect(function () {
    updateSearchQueryString(searchCriteriaStore, history, location);
    setPageTitle();
    if (loadingActivities) {
      liveAnnounce(formatText('lx.search.loadingActivities'), Level.POLITE);
    } else {
      liveAnnounce(formatText('lx.search.activitiesLoaded'), Level.POLITE);
    }
  });
  React.useEffect(function () {
    if (inputs && !skipQuery) {
      setSkipQuery(true);
    }
  }, [inputs, skipQuery]);
  logger.logEvent(RENDERING_ACTIVITY_SEARCH_COMPONENT);
  var oneKeyToggleHandler = React.useCallback(function (isChecked) {
    updateSearch({
      history: history,
      location: location,
      newParams: {
        swp: isChecked ? 'on' : 'off'
      },
      newState: {},
      replace: true
    });
  }, [history, location]);
  var handleSubmit = function (event, inputCriteria) {
    event.preventDefault();
    // have to use setTimeout to ensure in mweb the search criteria is updated with the new date range, not the stale one
    setTimeout(function () {
      updateQueryForSearch(inputCriteria, localDateFormat, history, location);
    }, 50);
  };
  var updatedDates = getDateRangeFromUrl(new URLSearchParams(location.search), localDateFormat);
  return React.createElement(React.Fragment, null, React.createElement(UitkViewTemplateSearchResults, {
    changeSearch: React.createElement(React.Fragment, null, React.createElement("h1", {
      className: "is-visually-hidden"
    }, localizedPageTitle), React.createElement(Experiment, {
      name: "Shared_UI_Activities_Playback_on_SRP"
    }, React.createElement(ExperimentControl, null, React.createElement(SrpSearchForm, {
      onSubmit: submitNewSearch,
      numDaysBookableInAdvance: numOfDaysBookableInAdvance,
      searchQuery: searchQuery,
      loading: loadingActivities,
      forceOpen: Boolean(searchError) || !isActivityGroupsAvailable
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement("div", {
      "data-testid": "activity-search-form"
    }, React.createElement(RefProviderRoot, null, React.createElement(ActivitySearchForm, {
      inputs: {
        activitySearchCriteria: {
          primary: {
            destination: inputs.destination,
            dateRange: updatedDates
          }
        }
      },
      onSubmit: handleSubmit,
      autoSubmitOnFieldChange: true,
      includePlayback: true,
      skipQuery: skipQuery
    })))))),
    searchHeading: React.createElement(UitkLayoutFlex, {
      space: "two",
      direction: "column",
      tag: "section"
    }, React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(React.Fragment, null)), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(UitkSpacing, {
      margin: {
        small: {
          blockend: 'two'
        },
        medium: {
          blockend: 'three'
        }
      }
    }, React.createElement("div", {
      "data-stid": "onekeybanner-toggle"
    }, React.createElement(OneKeyBanner, {
      inputs: {
        useLoyaltyCurrency: !(searchQuery.swp && searchQuery.swp === 'off'),
        pageLocation: PageLocation.SEARCH_RESULTS,
        lineOfBusiness: LineOfBusinessDomain.ACTIVITIES
      },
      switchHandler: oneKeyToggleHandler
    }))))), React.createElement(UitkLayoutFlexItem, null, React.createElement(CustomerNotifications, {
      location: CustomerNotificationLocation.AFTER_HEADER,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    })), React.createElement(UitkLayoutFlexItem, null, React.createElement("b", null, React.createElement(CustomerNotifications, {
      location: CustomerNotificationLocation.IN_PAGE,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    }))), React.createElement(UitkLayoutFlexItem, null, searchError ? React.createElement(ErrorBanner, {
      type: ErrorMessageType.SEARCH_ERROR,
      onButttonClick: function () {
        return submitNewSearch(searchQuery);
      }
    }) : null, React.createElement(SearchMessageBanner, null)), React.createElement(UitkLayoutFlexItem, null, React.createElement(Viewport, null, React.createElement(ViewLarge, null), React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, (!searchError && isValidActivityGroupsAvailable || !searchError && loadingActivities) && React.createElement(Experiment, {
      name: "Activities_UniversalSortFilterSchema_All_Devices"
    }, React.createElement(ExperimentControl, null, React.createElement(SortFilterDialog, {
      loading: loadingActivities
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(UitkSpacing, {
      margin: {
        blockend: 'six'
      }
    }, React.createElement(UniversalSortFilterWrapper, {
      view: SortAndFiltersViewType.SORT_AND_FILTERS
    }))))))))),
    searchFilters: React.createElement(UitkLayoutGridItem, {
      colSpan: {
        large: 3
      }
    }, React.createElement("section", null, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(React.Fragment, null, (!searchError && isValidActivityGroupsAvailable || !searchError && loadingActivities) && React.createElement(Experiment, {
      name: "Activities_UniversalSortFilterSchema_All_Devices"
    }, React.createElement(ExperimentControl, null, React.createElement(SortFilter, {
      loading: loadingActivities,
      inDialog: false
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(UniversalSortFilterWrapper, {
      view: SortAndFiltersViewType.FILTERS
    })))))))),
    searchResults: React.createElement(React.Fragment, null, (appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length) > 0 && React.createElement(FilterPills, {
      filters: appliedFilters,
      clearLabel: clearAll === null || clearAll === void 0 ? void 0 : clearAll.primary,
      clearAnalytics: (_c = clearAll === null || clearAll === void 0 ? void 0 : clearAll.action) === null || _c === void 0 ? void 0 : _c.analytics,
      clearURL: (_d = clearAll === null || clearAll === void 0 ? void 0 : clearAll.action) === null || _d === void 0 ? void 0 : _d.resource.relativePath
    }), React.createElement(Breadcrumbs, null), (loadingActivities || isActivityGroupsAvailable) && React.createElement(DestinationView, {
      messages: messages,
      showMoreLoading: showMoreLoading
    })),
    sideRailAd: React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(UitkSpacing, {
      margin: {
        inlinestart: 'six'
      }
    }, React.createElement("aside", {
      className: "max-height",
      "data-testid": "activity-search-page-meso-0"
    }, React.createElement(MesoDisplayAd, {
      uci: "R1",
      slot: "R1"
    }), React.createElement(UitkSpacing, {
      padding: {
        block: 'three'
      }
    }, React.createElement("div", {
      className: "sticky-top--with-navbar"
    }, React.createElement(MesoDisplayAd, {
      uci: "R2",
      slot: "R2"
    })))))))
  }), React.createElement(UitkSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(UitkLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement("div", {
    "data-testid": "activity-search-page-meso-1"
  }, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(MesoDisplayAd, {
    uci: "CM1",
    slot: "CM1"
  })), React.createElement(ViewMedium, null, React.createElement(MesoDisplayAd, {
    uci: "CM2",
    slot: "CM2"
  })), React.createElement(ViewSmall, null, React.createElement(MesoDisplayAd, {
    uci: "CM3",
    slot: "CM3"
  }))))))));
}));